import moment from 'moment';
import { displayDate, DATE_AT_TIME } from 'utils/date';
import { sentenceCase } from 'utils/stringHelpers';

const asPluralDate = (dateType: string, dateDelta: number, override?: number) => {
  // Allow an override, but prevent zero format
  const numericResult = (override ?? dateDelta) || 1;
  return numericResult === 1
    ? `${numericResult} ${dateType} ago`
    : `${numericResult} ${dateType}s ago`;
};

export const getRelativeToMonthSpan = (scoreDate: string | number) => {
  if (!scoreDate) {
    return '';
  }

  const hoursDiff = moment(new Date()).diff(moment(scoreDate), 'hours');
  if (hoursDiff <= 20) {
    return asPluralDate('hour', hoursDiff);
  }

  const daysDiff = moment(new Date()).diff(moment(scoreDate), 'days');
  if (daysDiff <= 6) {
    return asPluralDate('day', daysDiff);
  }

  const weeksDiff = moment(new Date()).diff(moment(scoreDate), 'weeks');
  // Max number of weeks is 4
  return asPluralDate('week', weeksDiff, weeksDiff > 4 ? 4 : weeksDiff);
};

export const formatToDisplayDate = (date: string | undefined) => displayDate(date, DATE_AT_TIME);

export const constructEngagementEvent = (event: string) => {
  const pluralCases = ['sends', 'opens', 'clicks'];
  if (pluralCases.includes(event)) {
    return `Total ${sentenceCase(event)}`;
  } else {
    return `Total ${sentenceCase(event)}s`;
  }
};
